module.exports = __webpack_public_path__ + "static/media/bell1.38693673.svg";